// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__xg_x7","itemLink":"Item_itemLink___0W9c"};